import { z } from 'zod';

const cardPreferenceSchema = z.object({
   selectedOption: z.enum(['card', 'free'], { required_error: 'Please select an option' }),
});

export type TCardPreference = z.infer<typeof cardPreferenceSchema>;

export { cardPreferenceSchema };
